<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <h6 class="mb-0 text-center">
        <span class="titulo-sagres font-weight-bold">
          {{ isEdit ? 'Editar' : 'Cadastrar' }} Convênio / Outros Instrumentos Congêneres
        </span>
        <btn-voltar />
      </h6>
    </template>
    <b-tabs card>
      <b-tab title="Dados gerais" active>
        <div id="tabDadosGerais">
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form @submit.stop.prevent="handleSubmit(salvarDadosGerais)">
              <b-row>
                <b-col cols="12" md="4" lg="2">
                  <validation-provider rules="required" v-slot="validationContext" name="numeroConvenio">
                    <b-form-group id="input-group-type" label-size="md" label="Nº Instrumento *" label-cols="auto"
                      content-cols="12">
                      <b-form-input id="input-numeroConvenio" v-model="convenio.NrConvenio"
                        :state="getValidationState(validationContext)" type="number"></b-form-input>
                      <b-form-invalid-feedback id="input-numeroConvenio-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" md="4" lg="2">
                  <validation-provider rules="required" v-slot="validationContext" name="numeroAnoConvenio">
                    <b-form-group id="input-group-type" label-size="md" label="Ano Instrumento *" label-cols="auto"
                      content-cols="12">
                      <b-form-input id="input-numeroAnoConvenio" v-model="convenio.NrAnoConvenio"
                        :state="getValidationState(validationContext)" type="number"></b-form-input>
                      <b-form-invalid-feedback id="input-numeroAnoConvenio-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <validation-provider rules="required|min_value:1" v-slot="validationContext" name="tipoConvenio">
                    <b-form-group id="input-group-type" label-size="md" label="Tipo de Instrumento *" label-cols="auto"
                      content-cols="12">
                      <b-form-select id="select-tipoConvenio" v-model="convenio.IdTipoConvenio"
                        :options="listaTiposConvenio" @change="handleTipoConvenioChange"
                        :state="getValidationState(validationContext)">
                      </b-form-select>
                    </b-form-group>
                    <b-form-invalid-feedback id="select-tipoConvenio-live-feedback">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
                <b-col v-if="isAutorEmendaRequired" cols="12" md="4">
                  <validation-provider :rules="isAutorEmendaRequired ? 'required|max:100' : ''" v-slot="validationContext"
                    name="autorEmenda">
                    <b-form-group id="input-group-type" label-size="md"
                      :label="isAutorEmendaRequired ? 'Autor da Emenda (vereador) *' : 'Autor da Emenda (vereador)'" label-cols="auto" content-cols="12">
                      <b-form-input id="input-autorEmenda" v-model="convenio.NmAutorEmenda"
                        :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback id="input-autorEmenda-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col v-else cols="12" md="4">
                </b-col>
                <b-col cols="12" md="4">
                  <validation-provider rules="required|max:1000" v-slot="validationContext" name="objetoConvenio">
                    <b-form-group id="objetoConvenio-input-group" label="Objeto *" label-for="input-objetoConvenio"
                      label-cols="auto" content-cols="12">
                      <b-form-textarea id="input-objetoConvenio" :state="getValidationState(validationContext)"
                        v-model="convenio.DeObjetoConvenio" rows="3" max-rows="6"></b-form-textarea>
                      <b-form-invalid-feedback id="input-objetoConvenio-live-feedback">{{ validationContext.errors[0]
                      }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <default-form-validation-provider label="Início de vigência" v-slot="defaultState">
                    <b-form-datepicker :state="defaultState.state" v-model="convenio.DtInicioVigencia"
                      v-bind="datePickerProps" reset-button>
                    </b-form-datepicker>
                  </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <default-form-validation-provider label="Fim de vigência" v-slot="defaultState">
                    <b-form-datepicker :state="defaultState.state" v-model="convenio.DtFimVigencia"
                      v-bind="datePickerProps" reset-button>
                    </b-form-datepicker>
                  </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <default-form-validation-provider label="Data de Publicação" v-slot="defaultState">
                    <b-form-datepicker :state="defaultState.state" v-model="convenio.DtPublicacao"
                      v-bind="datePickerProps" reset-button>
                    </b-form-datepicker>
                  </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <default-form-validation-provider label="Data de Celebração" v-slot="defaultState">
                    <b-form-datepicker :state="defaultState.state" v-model="convenio.DtCelebracao" reset-button
                      v-bind="datePickerProps" />
                  </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <validation-provider rules="required" v-slot="validationContext" name="veiculoPublicacaoConvenio">
                    <b-form-group id="input-group-type" label-size="md" label="Veículo de Publicação *" label-cols="auto"
                      content-cols="12">
                      <b-form-input id="input-veiculoPublicacaoConvenio" v-model="convenio.NmVeiculoPublConv"
                        :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback id="input-veiculoPublicacaoConvenio-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <validation-provider :rules="isDadosBancariosRequired ? 'required' : ''" v-slot="validationContext"
                    name="banco">
                    <b-form-group id="input-group-type" label-size="md"
                      :label="isDadosBancariosRequired ? 'Banco *' : 'Banco '" label-cols="auto" content-cols="12">
                      <b-form-select id="select-banco" v-model="convenio.CdBancoConv" :options="listaBancos"
                        @change="handleTipoConvenioChange" :state="getValidationState(validationContext)">
                      </b-form-select>
                    </b-form-group>
                    <b-form-invalid-feedback id="select-tipoConvenio-live-feedback">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <validation-provider :rules="isDadosBancariosRequired ? 'required' : ''" v-slot="validationContext"
                    name="codigoAgenciaConvenio">
                    <b-form-group id="input-group-type" label-size="md"
                      :label="isDadosBancariosRequired ? 'Agência *' : 'Agência '" label-cols="auto" content-cols="12">
                      <b-form-input id="input-codigoAgenciaConvenio" v-model="convenio.CdAgenciaConv"
                        :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback id="input-codigoAgenciaConvenio-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <validation-provider :rules="isDadosBancariosRequired ? 'required' : ''" v-slot="validationContext"
                    name="numeroContaConvenio">
                    <b-form-group id="input-group-type" label-size="md"
                      :label="isDadosBancariosRequired ? 'Conta *' : 'Conta'" label-cols="auto" content-cols="12">
                      <b-form-input id="input-numeroContaConvenio" v-model="convenio.NrContaConv"
                        :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback id="input-numeroContaConvenio-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group class="formGroup mb-5" id="arquivo-edital-input-group"
                    label="Arquivo Texto do Instrumento (PDF) *"
                    label-for="input-arquivo-edital" label-cols="auto" content-cols="12">
                    <validation-provider v-if="!existeArquivoEdital()" rules="required" v-slot="validationContext"
                      name="arquivoEdital">
                      <b-form-file v-model="arquivoEditalForm" :state="getValidationState(validationContext)"
                        placeholder="Selecione..." drop-placeholder="Solte o arquivo aqui..." class=""
                        browse-text="Escolher" accept=".pdf"></b-form-file>
                      <b-form-invalid-feedback id="input-arquivo-edital-live-feedback">{{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                    <div v-else class="d-flex justify-content-center">
                      <btn-download class="mr-2" :fazerDownload="baixarAnexo" :parametros="arquivoEdital" />
                      <b-link class="text-dark" @click="removerArquivoEdital()">
                        <font-awesome-icon icon="times" />
                        <div style="font-size: 12px">Remover</div>
                      </b-link>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <br>
              <b-button class="float-right m-3" size="sm" type="submit">
                <font-awesome-icon icon="save" />
                Salvar dados gerais
              </b-button>
            </b-form>
          </validation-observer>
        </div>
      </b-tab>
      <b-tab title="Participantes">
        <b-alert v-if="!habilitarFormParticipantes" :show="!habilitarFormParticipantes" variant="warning">Salve os dados
          gerais para adicionar
          participantes ao instrumento.</b-alert>
        <div v-else id="tabParticipantes">
          <b-row>
            <b-col cols="12" lg="4">
              <b-form-group id="input-group-type" label-size="md" label="Nome do Participante" label-cols="auto"
                content-cols="12">
                <b-form-input id="input-nomeParticipanteConvenio"
                  v-model="participanteForm.NmParticipante"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-group id="input-group-type" label-size="md" label="CPF/CNPJ" label-cols="auto" content-cols="12">
                <b-form-input id="input-cpfParticipanteConvenio" maxlength="18"
                  v-model="participanteForm.CdCpfCnpjParticipante"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-group id="input-group-type" label-size="md" label="Valor de Participação (R$)" label-cols="auto"
                content-cols="12">
                <money id="input-valorParticipanteConvenio" class="form-control" v-model="participanteForm.VlParticipacao"
                  v-bind="vMoneyOptions" />
              </b-form-group>
            </b-col>
            <b-col class="mb-3 d-flex align-items-center">
              <b-button size="sm" :disabled="!isParticipantePreenchido" @click="adicionarParticipante(participanteForm)">
                <font-awesome-icon icon="plus" />
                Adicionar Participante
              </b-button>
            </b-col>
          </b-row>
          <b-table :busy="tableBusy" :fields="fieldsParticipantes" hover no-border-collapse :items="participantesConvenio"
            sort-by="" :sort-desc="true" striped stacked="md" show-empty small>
            <template #empty>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
              <div class="text-center text-dark">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="loading-text">Carregando...</strong>
              </div>
            </template>
            <template v-slot:cell(actions)="row">
              <div class="actions-icons">
                <btn-excluir :idItem="row.item.IdParticipanteConvenio" :excluirItem="removerParticipante" />
              </div>
            </template>
          </b-table>
        </div>
      </b-tab>
    </b-tabs>

  </b-card>
</template>

<script lang="ts">
import BtnVoltar from '@/components/shared/BtnVoltar.vue';
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue';
import BtnDownload from '@/components/shared/btn-download.vue';
import BtnExcluir from '@/components/shared/btn-excluir.vue';
import conveniosService from '@/services/licitacoes/conveniosService';
import { store } from "@/store";
import { DatePickerDefaultProps } from '@/types/form-default-props';
import { ArquivoConvenio } from '@/types/licitacoes/arquivo-convenio';
import { Convenio } from '@/types/licitacoes/convenio';
import { TiposConvenioEnum } from '@/types/licitacoes/enums/tipos-convenio';
import { fieldsParticipantes } from '@/types/licitacoes/fields-participantes';
import { ParticipanteConvenio } from '@/types/licitacoes/participante-convenio';
import { TipoConvenio } from '@/types/licitacoes/tipo-convenio';
import { TableField } from '@/types/table-field';
import { UtilsTS } from '@/utilsts';
import { Money } from 'v-money';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';

const CompProps = Vue.extend({
  name: 'EditarConvenio',
  components: { BtnVoltar, BtnDownload, BtnExcluir, DefaultFormValidationProvider, Money, ValidationProvider, ValidationObserver },
  props: {
    idConvenio: {
      type: String,
      required: false
    }
  }
})

@Component
export default class EditarConvenio extends mixins(UtilsTS, CompProps) {
  datePickerProps = DatePickerDefaultProps
  listaTiposConvenio: TipoConvenio[] = []
  listaBancos: any[] = []
  tableBusy = false
  convenio: Convenio = new Convenio()
  arquivoEdital: ArquivoConvenio = new ArquivoConvenio()
  arquivoCancelamento: ArquivoConvenio = new ArquivoConvenio()
  arquivoEditalForm = null
  arquivoCancelamentoForm = null
  isMotivoCancelamentoAvailable = false
  isDadosBancariosRequired = false
  isAutorEmendaRequired = false
  participantesConvenio: ParticipanteConvenio[] = []
  participanteForm: ParticipanteConvenio = new ParticipanteConvenio()
  fieldsParticipantes: TableField[] = fieldsParticipantes
  habilitarFormParticipantes = false
  convenioSalvo = false

  get isEdit() {
    return this.convenioSalvo || (this.idConvenio !== undefined && this.idConvenio !== null)
  }

  get isParticipantePreenchido() {
    return (this.participanteForm.CdCpfCnpjParticipante !== null && this.participanteForm.CdCpfCnpjParticipante !== undefined && this.participanteForm.CdCpfCnpjParticipante !== "") &&
      (this.participanteForm.NmParticipante !== null && this.participanteForm.NmParticipante !== undefined && this.participanteForm.NmParticipante !== "") &&
      (this.participanteForm.VlParticipacao !== null && this.participanteForm.VlParticipacao !== undefined)
  }

  handleDataCancelamentoInput(): void {
    this.isMotivoCancelamentoAvailable = this.convenio.DtCancelamentoConv != null
    if (!this.isMotivoCancelamentoAvailable)
      this.convenio.DeMotivoCancelConv = null
  }

  handleTipoConvenioChange() {
    this.isDadosBancariosRequired = this.convenio.IdTipoConvenio == TiposConvenioEnum.CONVENIO_DE_RECEITA
    this.isAutorEmendaRequired = this.convenio.IdTipoConvenio == TiposConvenioEnum.EMENDA_IMPOSITIVA_MUNICIPAL
  }

  getArquivoEdital(arquivos: ArquivoConvenio[]) {
    const arquivo = arquivos.find(x => x.IsArquivoEdital === true)
    return arquivo;
  }

  getArquivoCancelamento(arquivos: ArquivoConvenio[]) {
    const arquivo = arquivos.find(x => x.IsArquivoEdital === false)
    return arquivo;
  }

  async adicionarParticipante(participante: ParticipanteConvenio) {
    store.blockScreen = true
    const response = await conveniosService.adicionarParticipante(participante, this.convenio.IdConvenio.toString())
    if (response && response.status === 200) {
      this.participantesConvenio.push(response.data)
      this.participanteForm = new ParticipanteConvenio()
      this.$toast.success("Participante adicionado com sucesso");
    }
    else if (response && [400, 403].includes(response.status) && response.data.erros) {
      response.data.erros.forEach(erro => {
        this.$toast.error(erro, {
          timeout: false
        });
      });
    }
    else {
      throw new Error(response?.data && response?.data?.msg ? response.data.msg : 'Erro ao adicionar participante.')
    }
    store.blockScreen = false
  }

  async removerParticipante(idParticipanteConvenio: string) {
    store.blockScreen = true
    const index = this.participantesConvenio.findIndex(x => x.IdParticipanteConvenio === +idParticipanteConvenio)
    const response = await conveniosService.removerParticipante(idParticipanteConvenio)
    if (response && response.status === 204) {
      this.participantesConvenio.splice(index, 1)
      this.$toast.success("Participante removido com sucesso");
    }
    else if (response && response.status === 400 && response.data.erros) {
      response.data.erros.forEach(erro => {
        this.$toast.error(erro, {
          timeout: false
        });
      });
    }
    else {
      throw new Error(response?.data && response?.data?.msg ? response.data.msg : 'Erro ao remover participante.')
    }
    store.blockScreen = false
  }

  async buscarDadosDoConvenio(idConvenio: string) {
    store.blockScreen = true
    const convenioApi = await conveniosService.buscarConvenio(idConvenio)
    if (convenioApi && convenioApi.status === 200) {
      this.convenio = Object.assign(this.convenio, convenioApi.data)
      this.convenio.tratarDadosDaAPI()
      const arqEdital = this.getArquivoEdital(this.convenio.ArquivoConvenio)
      const arqCancelamento = this.getArquivoCancelamento(this.convenio.ArquivoConvenio)
      this.arquivoEdital = arqEdital ? Object.assign(this.arquivoEdital, arqEdital) : new ArquivoConvenio()
      this.arquivoCancelamento = arqCancelamento ? Object.assign(this.arquivoCancelamento, arqCancelamento) : new ArquivoConvenio()
      this.handleTipoConvenioChange()
      this.handleDataCancelamentoInput()
      this.participantesConvenio = convenioApi.data.ParticipanteConvenio
      this.habilitarFormParticipantes = true
    }
    else {
      this.$router.push("/modulo-licitacoes/convenios-outros-instrumentos-congeneres");
      this.$toast.error(convenioApi.data.msg || "Erro ao carregar instrumento");
    }
    store.blockScreen = false
  }

  async mounted() {
    try {
      store.blockScreen = true

      if (this.isEdit) {
        await this.buscarDadosDoConvenio(this.idConvenio);
      }
      else {
        this.convenio.IdTipoConvenio = 0
        this.convenio.CdBancoConv = ''
        this.convenio.ArquivoConvenio = []
      }
      const responseTiposConvenio = await conveniosService.listarTiposConvenio()
      this.listaTiposConvenio = [{ value: 0, text: 'SELECIONE UMA OPÇÃO', disabled: true }, ...responseTiposConvenio.data.map(t => ({ value: t.IdTipoConvenio, text: t.DeTipoConvenio }))]

      const responseListaBancos = await conveniosService.listarBancos()
      this.listaBancos = [{ value: '', text: 'SELECIONE UMA OPÇÃO', disabled: true }, ...responseListaBancos.data.map(b => ({ value: b.Codigo, text: `${b.Codigo} - ${b.Descricao}` }))]
    } catch (e: any) {
      console.error('Erro ao montar edição de instrumento', e)
      this.$router.push("/modulo-licitacoes/convenios-outros-instrumentos-congeneres");
      this.$toast.error(e.message || "Erro ao carregar instrumento");
    } finally {
      store.blockScreen = false
    }
  }

  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }

  existeArquivoEdital() {
    return this.arquivoEdital.IdConvenio > 0 ? true : false
  }

  existeArquivoCancelamento() {
    return this.arquivoCancelamento.IdConvenio > 0 ? true : false
  }

  async removerArquivoEdital() {
    this.arquivoEdital = new ArquivoConvenio()
  }

  async removerArquivoCancelamento() {
    this.arquivoCancelamento = new ArquivoConvenio()
  }

  async baixarAnexo(arquivo: ArquivoConvenio) {
    const response = await conveniosService.baixarAnexo(arquivo.IdArquivo)
    this.download(arquivo.DeNomeArquivo, response.data)
  }

  async salvarDadosGerais() {
    try {
      store.blockScreen = true
      const response = this.isEdit ? await conveniosService.editarConvenio(+this.convenio.IdConvenio, this.convenio, this.arquivoEditalForm) : await conveniosService.adicionarConvenio(this.convenio, this.arquivoEditalForm)
      if (response && response.status === 200) {
        this.$toast.success('Dados gerais do instrumento salvos com sucesso.')
        await this.buscarDadosDoConvenio(response.data.IdConvenio)
        this.habilitarFormParticipantes = true
        this.convenioSalvo = true
      }
      else if (response && [400, 403].includes(response.status) && response.data.erros) {
        response.data.erros.forEach(erro => {
          this.$toast.error(erro, {
            timeout: false
          });
        });
      }
      else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao salvar instrumento.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }
    finally {
      store.blockScreen = false
    }
  }
};
</script>
  
<style></style>